import * as React from 'react';
import {PureComponent} from 'react';
import {mapControlStyle} from "./mapControlStyle";

export default class ZoomInIcon extends PureComponent <any, any> {

    render() {
        return (
            <svg viewBox="0 0 200 200" style={{...mapControlStyle}}>
                <path d="M100,37.7c31.4,0,56.8,25.4,56.8,56.8c0,31.4-25.4,56.8-56.8,56.8c-31.3,0-56.8-25.4-56.8-56.8
                    C43.2,63.1,68.6,37.7,100,37.7z"/>
                <line x1="100.9" y1="117.1" x2="101.1" y2="71.9"/>
                <line x1="122.6" y1="94.5" x2="77.4" y2="94.3"/>
            </svg>
        );
    }
}